import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {EmojiIcon} from '@Components/emoji-icon/emoji-icon';
import {Button, Size, Type} from '@Components/button';
import {onAddBrandAssetClickedHandler} from '@Components/poster-editor/library/poster-editor-library';
import type {BrandKitsEmptyStateBoxProps} from './brand-kits-empty-state-box.types';
import {BrandKitsEmptyMessageType} from './brand-kits-empty-state-box.types';

export function BrandKitsEmptyStateBox({emptyMessageType, canUserAccessBrandKits, className = '', textClassName = '', ctaClassName = ''}: BrandKitsEmptyStateBoxProps): ReactElement<any> {
  /**
   * showing incomplete BK message only makes sense when the user has brand kits but they have no assets
   * non-premium plus users cannot have brand kits to begin with
   */
  const isMessageTypeForNoBrandKits = (): boolean => {
    return emptyMessageType === BrandKitsEmptyMessageType.NO_BRAND_KITS || !canUserAccessBrandKits;
  };

  const getEmptyStateMessage = (): string => {
    if (isMessageTypeForNoBrandKits()) {
      return window.i18next.t('pmwjs_you_dont_have_a_brand_kit_available');
    }

    return window.i18next.t('pmwjs_you_have_not_added_assets_to_your_brand_kits');
  };

  const getCTAText = (): string => {
    if (isMessageTypeForNoBrandKits()) {
      return window.i18next.t('pmwjs_add_a_brand_kit');
    }

    return window.i18next.t('pmwjs_update_brand_kit');
  };

  const onClickAddBrandKit = (): void => {
    void onAddBrandAssetClickedHandler(false);
  }

  return (
    <div className={`flex-v-row flex-items-center ${className}`}>
      <EmojiIcon emoji="😔" />
      <Text val={getEmptyStateMessage()} className={`content-body spacing-m-t-3 ${textClassName}`} size={TextSize.XSMALL} />
      <Button
        text={getCTAText()}
        type={Type.SECONDARY}
        size={Size.SMALL}
        customClasses={`${ctaClassName} -noun`}
        icon="icon-plus"
        onClick={onClickAddBrandKit}
        showPremiumUpsellIcon={!canUserAccessBrandKits}
      />
    </div>
  );
}
